import * as moment from "moment";
import { auth, database } from "../firebase";

export const fetchAllResponses = async (info) => {
  try {
    const allResponses = { answerYes: 0, answerNo: 0, answerMaybe: 0 };
    const responses = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("responses")
      .orderBy("timestamp")
      .startAt(info.filter.range.start)
      .endAt(info.filter.range.end)
      .get();
    if (responses.size > 0) {
      responses.forEach((response) => {
        if (response.data().response === "No") {
          allResponses["answerNo"] += 1;
        } else if (response.data().response === "Yes") {
          allResponses["answerYes"] += 1;
        } else if (response.data().response === "Maybe") {
          allResponses["answerMaybe"] += 1;
        }
      });
    }
    return Promise.all([responses, allResponses]).then((result) => {
      if (result[1]) {
        return {
          payload: [
            result[1].answerYes,
            result[1].answerNo,
            result[1].answerMaybe,
          ],
          error: null,
        };
      } else {
        throw new Error("Fetch error");
      }
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const fetchAllSales = async (info) => {
  try {
    const currentStart = moment.unix(info.filter.range.start);
    const currentEnd = moment.unix(info.filter.range.end);

    const diff = moment.duration(currentEnd.diff(currentStart));

    const compareEnd = moment(
      currentStart
        .subtract({ days: 1 })
        .set({ hours: 23, minutes: 59, seconds: 59 })
    );
    const compareStart = moment(compareEnd).subtract(diff);

    const compareEndUnix = moment(compareEnd).unix();
    const compareStartUnix = moment(compareStart).unix();

    const currentList = [];
    const prevList = [];

    const currentSales = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("sales")
      .orderBy("timestamp")
      .startAt(info.filter.range.start)
      .endAt(info.filter.range.end)
      .get();
    const prevSales = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("sales")
      .orderBy("timestamp")
      .startAt(compareStartUnix)
      .endAt(compareEndUnix)
      .get();

    if (currentSales.size > 0) {
      currentSales.forEach((curSale) => {
        currentList.push({ timestamp: curSale.data().timestamp * 1000 });
      });
    }

    if (prevSales.size > 0) {
      prevSales.forEach((prevSale) => {
        prevList.push({ timestamp: prevSale.data().timestamp * 1000 });
      });
    }

    return Promise.all([currentList, prevList])
      .then((result) => {
        return {
          payload: { current: result[0], previous: result[1] },
          error: null,
        };
      })
      .catch((e) => {
        return { payload: null, error: "error" };
      });
  } catch (e) {
    throw new Error(e);
  }
};

export const fetchAllClients = async (info) => {
  try {
    const currentStart = moment.unix(info.filter.range.start);
    const currentEnd = moment.unix(info.filter.range.end);

    const diff = moment.duration(currentEnd.diff(currentStart));

    const compareEnd = moment(
      currentStart
        .subtract({ days: 1 })
        .set({ hours: 23, minutes: 59, seconds: 59 })
    );
    const compareStart = moment(compareEnd).subtract(diff);

    const compareEndUnix = moment(compareEnd).unix();
    const compareStartUnix = moment(compareStart).unix();

    const currentList = [];
    const prevList = [];

    const currentClients = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("clients")
      .orderBy("timestamp")
      .startAt(info.filter.range.start)
      .endAt(info.filter.range.end)
      .get();
    const prevClients = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("clients")
      .orderBy("timestamp")
      .startAt(compareStartUnix)
      .endAt(compareEndUnix)
      .get();

    if (currentClients.size > 0) {
      currentClients.forEach((curClient) => {
        currentList.push({ timestamp: curClient.data().timestamp * 1000 });
      });
    }

    if (prevClients.size > 0) {
      prevClients.forEach((prevClient) => {
        prevList.push({ timestamp: prevClient.data().timestamp * 1000 });
      });
    }

    return Promise.all([currentList, prevList]).then((result) => {
      return {
        payload: { current: result[0], previous: result[1] },
        error: null,
      };
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const fetchAllDeliveries = async (info) => {
  try {
    const currentStart = moment.unix(info.filter.range.start);
    const currentEnd = moment.unix(info.filter.range.end);

    const diff = moment.duration(currentEnd.diff(currentStart));

    const compareEnd = moment(
      currentStart
        .subtract({ days: 1 })
        .set({ hours: 23, minutes: 59, seconds: 59 })
    );
    const compareStart = moment(compareEnd).subtract(diff);

    const compareEndUnix = moment(compareEnd).unix();
    const compareStartUnix = moment(compareStart).unix();

    const currentList = [];
    const prevList = [];

    const currentDeliveries = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("deliveries")
      .orderBy("dateAdded")
      .startAt(info.filter.range.start)
      .endAt(info.filter.range.end)
      .get();
    const prevDeliveries = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("deliveries")
      .orderBy("dateAdded")
      .startAt(compareStartUnix)
      .endAt(compareEndUnix)
      .get();

    if (currentDeliveries.size > 0) {
      currentDeliveries.forEach((curDelivery) => {
        currentList.push({ timestamp: curDelivery.data().timestamp * 1000 });
      });
    }

    if (prevDeliveries.size > 0) {
      prevDeliveries.forEach((prevDelivery) => {
        prevList.push({ timestamp: prevDelivery.data().timestamp * 1000 });
      });
    }

    return Promise.all([currentList, prevList]).then((result) => {
      return {
        payload: { current: result[0], previous: result[1] },
        error: null,
      };
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const fetchAllRevenue = async (info) => {
  try {
    const revenueData = [];

    const unfilteredStart = moment().set({ year: info.year }).startOf("year");
    const filterStart = unfilteredStart.unix();

    const unfilteredEnd = moment().set({ year: info.year }).endOf("year");
    const filteredEnd = unfilteredEnd.unix();

    const allRevenue = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("sales")
      .orderBy("timestamp")
      .startAt(filterStart)
      .endAt(filteredEnd)
      .get();

    if (allRevenue.size > 0) {
      allRevenue.forEach((revenue) => {
        revenueData.push({
          price: revenue.data().price,
          timestamp: revenue.data().timestamp,
          vat: revenue.data().vat,
        });
      });
    }

    return Promise.all(revenueData).then((result) => {
      return { payload: result, error: null };
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const fetchSaleBy = (sale) => {
  return new Promise((resolve, reject) => {
    database
      .collection("users")
      .doc(sale.saleBy)
      .get()
      .then((user) => {
        if (user.exists) {
          resolve({
            amount: sale.amount,
            thumbnail: user.data().thumbnail,
            owner: `${user.data().firstName} ${user.data().lastName}`,
          });
        } else {
          reject("error");
        }
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const fetchAllYears = async (info) => {
  try {
    const dates = [];

    const regDate = await auth.currentUser?.metadata?.creationTime;

    const regDateFormatted = moment(regDate);
    const dateNowFormatted = moment(Date.now());

    for (
      var m = moment(regDateFormatted);
      m.isBefore(dateNowFormatted);
      m.add(1, "years")
    ) {
      dates.push(m.year());
    }

    return Promise.all(dates).then((result) => {
      return { payload: dates, error: null };
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const fetchActiveGoal = async (info) => {
  try {
    const search = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("goals")
      .where("type", "==", info.filter)
      .get();
    const id = search && search.docs[0].id;
    const goal = (search && search.docs[0].data()) || null;

    if (goal) {
      var result = null;

      const performance = await database
        .collection("companies")
        .doc(info.companyId)
        .collection(`${goal.type}`)
        .orderBy("timestamp")
        .startAt(goal.start)
        .endAt(goal.end)
        .get();
      const percentage = (performance.size * goal.amount) / 100;

      if (percentage < 0) {
        result = 0;
      } else if (percentage > 1) {
        result = 1;
      } else {
        result = percentage;
      }

      const final = result === 0 ? 0 : Math.round(result * 100).toFixed(1);

      const response = {
        id: id,
        data: goal,
        progress: final,
      };

      return { payload: response, error: null };
    } else {
      throw new Error("Kunne ikke hente mål.");
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const createNewGoal = async (info) => {
  try {
    const result = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("goals")
      .where("type", "==", info.goal.type)
      .get();

    if (result.size > 0) {
      const existingId = (result && result.docs && result.docs[0].id) || null;
      await database
        .collection("companies")
        .doc(info.companyId)
        .collection("goals")
        .doc(existingId)
        .delete();
      await database
        .collection("companies")
        .doc(info.companyId)
        .collection("goals")
        .add(info.goal);

      return { error: null };
    } else {
      await database
        .collection("companies")
        .doc(info.companyId)
        .collection("goals")
        .add(info.goal);
      return { error: null };
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteExistingGoal = async (info) => {
  try {
    await database
      .collection("companies")
      .doc(info.companyId)
      .collection("goals")
      .doc(info.goalId)
      .delete();
    return { error: null };
  } catch (e) {
    throw new Error(e);
  }
};

export const updateExistingGoal = async (info) => {
  try {
    await database
      .collection("companies")
      .doc(info.companyId)
      .collection("goals")
      .doc(info.id)
      .update(info.goal);
    return { error: null };
  } catch (e) {
    throw new Error(e);
  }
};
